export default __webpack_public_path__ + "static/media/LLF.4e3df0ca.png";